import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	makeStyles,
	Grid,
	Typography,
	ExpansionPanel,
	ExpansionPanelSummary,
	ExpansionPanelDetails,
	Divider
} from '@material-ui/core';
import Constants from '../utils/Constants';

const styles = makeStyles(theme => ({
	panelHeading: {
		fontWeight: "bold"
	},

	expandIcon: {
		marginLeft: theme.spacing(0.4)
	},

	iconItem: {
		paddingRight: theme.spacing(2)
	},

	detailsRoot: {
		display: "block"
	},
	panel: {
		borderRadius: "8px !important",
		border: `1px solid ${theme.palette.secondary.lightGrey}`,
		marginBottom: 10
	},
	subHeading: {
		color: theme.palette.secondary.grey,
		fontWeight: 400
	}
}));

function GeneralSettingsPanel(props) {
	let classes = styles(),
		{id, expanded, clickHandler, expandIcon,
			headingIcon, heading, subHeading, expandedDetails} = props;

	return (
		<ExpansionPanel
			elevation={2}
			className={classes.panel}
			expanded={expanded}
			onChange={clickHandler}>
			<ExpansionPanelSummary
				id={`${id}-header`}
				expandIcon={expandIcon || <FontAwesomeIcon icon={["far", "angle-down"]} />}
				aria-controls={`${id}-content`}
				classes={{
					expandIcon: classes.expandIcon
				}}>
				<Grid container wrap="nowrap">
					{/* <Grid item xs={2} sm={1} md={1} lg={1} xl={1} className={classes.iconItem}>
						<FontAwesomeIcon icon={headingIcon} size="2x" />
					</Grid> */}
					<Grid item>
						<Typography className={classes.panelHeading}>{heading}</Typography>
						<Typography className={classes.subHeading}>{subHeading}</Typography>
					</Grid>
				</Grid>
			</ExpansionPanelSummary>
			<ExpansionPanelDetails
				classes={{
					root: classes.detailsRoot
				}}>
					<Divider style={{marginBottom: 20}}/>
				{expandedDetails}
			</ExpansionPanelDetails>
		</ExpansionPanel>
	);
}

GeneralSettingsPanel.propTypes = {
	id: PropTypes.string.isRequired,
	expanded: PropTypes.bool,
	clickHandler: PropTypes.func,
	expandIcon: PropTypes.element,
	headingIcon: PropTypes.array,
	heading: PropTypes.any.isRequired,
	subHeading: PropTypes.any,
	expandedDetails: PropTypes.any
};

export default GeneralSettingsPanel;